import {Controller} from "@hotwired/stimulus"
import {post} from "@rails/request.js"

// Connects to data-controller="filter-export"
export default class extends Controller {

    static targets = ["form"]

    static values = {
        url: String
    }

    connect() {
    }

    async export(event) {
        event.preventDefault()

        let params = new URLSearchParams(new FormData(this.formTarget)).toString()
        window.open(this.urlValue + '?' + params)
    }


}
